import { useTypedDispatch, useTypedSelector } from "../../store"
import { AuthResponseDto, useAuthenticateTokenSuspenseQuery } from "src/graphql/quark/quark.type"
import { useEffect, useMemo } from "react"
import { loginState, updateWhLoc } from "./auth"

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useTypedDispatch()
  const authStore = useTypedSelector((state) => state.authentication)
  const token = useMemo(() => localStorage.getItem("token"), [])
  const { data } = useAuthenticateTokenSuspenseQuery({
    skip: !token,
    errorPolicy: "all"
  })
  useEffect(() => {
    const whLocId = localStorage.getItem("warehouseId") ?? localStorage.getItem("retailId")
    if (whLocId) {
      const whLoc = authStore.allowedLocations.find((val) => val?.id === whLocId)
      if (whLoc) dispatch(updateWhLoc(whLoc))
    }
  }, [authStore.allowedLocations])

  useEffect(() => {
    if (data?.authenticateToken) dispatch(loginState((data?.authenticateToken ?? {}) as AuthResponseDto))
  }, [data])

  return children
}
export default AuthProvider
